import { DeliveryTimeOptionEnum } from "@/enums/deliveryTimeOptionEnum";

export const DELIVERY_TIME_OPTIONS: DeliveryTimeOption[] = [
    DeliveryTimeOptionEnum.MORNING,
    DeliveryTimeOptionEnum.AFTERNOON,
    DeliveryTimeOptionEnum.ANYTIME,
];

export type DeliveryTimeOption =
    | DeliveryTimeOptionEnum.MORNING
    | DeliveryTimeOptionEnum.AFTERNOON
    | DeliveryTimeOptionEnum.ANYTIME;
